import * as React from "react";
import { Route, Routes } from "react-router-dom";
import { DeveloperNavigationPath } from "src/common/developers";
import {
  Icons, Buttons, Messaging, Typography, Forms, Cards, Description, Modals, Tabs, Breadcrumbs,
  Pagination, DragAndDrop, Popovers, ProgressBar, PublicCards, Scrollbar, DatePicker, Toastrs, Toolbar
} from "../developer/ui-guide";
import { DeveloperWrapper } from "./";

function UIGuides() {
  return (
    <DeveloperWrapper type={DeveloperNavigationPath.UiGuideNavigation}>
      <Routes>
        <Route path="/" element={<Description />} />
        <Route path="breadcrumbs" element={<Breadcrumbs />} />
        <Route path="buttons" element={<Buttons />} />
        <Route path="cards" element={<Cards />} />
        <Route path="date-picker" element={<DatePicker />} />
        <Route path="drag-and-drop" element={<DragAndDrop />} />
        <Route path="forms" element={<Forms />} />
        <Route path="icons" element={<Icons />} />
        <Route path="messaging" element={<Messaging />} />
        <Route path="modals" element={<Modals />} />
        <Route path="pagination" element={<Pagination />} />
        <Route path="popovers" element={<Popovers />} />
        <Route path="progress-bar" element={<ProgressBar />} />
        <Route path="public-cards" element={<PublicCards />} />
        <Route path="scrollbar" element={<Scrollbar />} />
        <Route path="tabs" element={<Tabs />} />
        <Route path="toastr" element={<Toastrs />} />
        <Route path="toolbar" element={<Toolbar />} />
        <Route path="typography" element={<Typography />} />
      </Routes>
    </DeveloperWrapper>
  );
}

export default React.memo(UIGuides);
